export default {
  name: 'customer_phone_number',
  component_path: 'modules/procedures/blocks/BlockInputTel'
}